import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { StateMasterService } from 'src/Services/state-master.service';
import { Main911Service } from 'src/Services/main911.service';
import { ContactsRate911Model } from 'src/Models/ContactsRate911Model';
import { CountyMasterService } from 'src/Services/county-master.service';
import { CityMasterService } from 'src/Services/city-master.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit, AfterViewInit, OnDestroy {
  stateCode: any;
  tokenKey: string;
  listofContacts: ContactsRate911Model[];
  listofContactsExport: ContactsRate911Model[]

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  FundName: string;

  upDowFundNameCSS: string = '';
  upDowContactTableNameCSS: string = '';
  upDowStateNameCSS: string = '';
  upDowCountyNameCSS = '';
  upDowCityNameCSS = '';
  upDowFirstNameCSS = '';
  upDowLastNameCSS = '';
  upDowLastDateCSS = '';
  upDowConfiDateCSS = '';
  upDowEmailCSS = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = [];
  stateId: string = ' ';
  stateList: any[] = [];

  dropdownListCounty = [];
  selectedItemsConuty = [];
  dropdownSettingsCounty = {};
  listOfCountyIds = [];
  countyId: string = ' ';
  countyList: any[] = [];
  ContactTableId: string = ' ';
  dropdownListContactTable = [];
  selectedItemsContactTable = [];
  dropdownSettingsContactTable = {};
  listofContactsTypeIds = [];
  ContactTableList: any[] = [];
  listofContactsTable: any[] = [];
  filterText: string = ' ';

  module = '911';
  contactId: number = 0;

  listOfColumnIds = [];
  ColumnId: any;
  selectedItemsColumn = [];
  dropdownSettingsColumn = {};
  ColumnList: any[] = [];
  dropdownListColumn = [];
  selectedItem: string = '';

  dropdownListCity = [];
  selectedItemsCity = [];
  dropdownSettingsCity = {};
  listOfCityIds = [];
  cityId: string = ' ';
  cityList: any[] = [];
  isCountyFilterLoading = false;
  isCityFilterLoading = false;
  isCitySelectionLoading = false;
  private isAllCitiesSelected = false;
  private isApplyingCitySelection = false;
  private cityDropdownPatched = false;
  private citySelectedIdMap: { [id: string]: boolean } = {};
  private readonly cityBadgeLimit = 50;
  private readonly allCitiesPlaceholderId = '__ALL_CITIES__';
  private readonly manyCitiesPlaceholderId = '__MANY_CITIES__';
  private countyLoad$ = new Subject<string>();
  private cityLoad$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  private countyApplySeq = 0;
  private cityApplySeq = 0;
  private citySelectionSeq = 0;
  @ViewChild('cityFilterDropdown', { static: false }) cityFilterDropdown: AngularMultiSelect;

  dropdownListScope = [];
  selectedItemsScope = [];
  dropdownSettingsScope = {};
  listOfScopeIds = [];
  scopeId: string = ' ';
  scopeList: any[] = [];

  fromDate?: string;
  toDate?: string;
  fromDate1?: string;
  toDate1?: string;
  rangeOfLastConfDates: any;
  rangeOfConfDates: any;
  openMenuIndex: number = -1;

  constructor(private readonly countyService: CountyMasterService, private readonly router: Router, private readonly main911Master: Main911Service, private readonly checkAuth: CheckAuth, private readonly titleService: Title, private readonly main911Service: Main911Service, private readonly cityService: CityMasterService, private readonly toastr: ToastrService, private readonly stateService: StateMasterService, private readonly ngZone: NgZone,private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofContacts = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'StateName';
    this.FundName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Contacts');

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsCounty = {
      singleSelection: false,
      text: "Filter by County",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No County(s) available',
      showCheckbox: true,
      lazyLoading: true
    };
    this.dropdownSettingsCity = {
      singleSelection: false,
      text: "Filter by City",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No City(s) available',
      showCheckbox: true,
      lazyLoading: true,
      enableCheckAll: true,
      enableFilterSelectAll: true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All"
    };
    this.dropdownSettingsScope = {
      singleSelection: false,
      text: "Filter by Fund Jurisdiction Level",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Fund Jurisdiction Level(s) available',
      showCheckbox: true,
    };
    this.dropdownSettingsContactTable = {
      singleSelection: true,
      text: "Filter by ContactTable",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No ContactTable(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsColumn = {
      singleSelection: true,
      text: "Filter by Column",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Column(s) available',
      showCheckbox: false,
      enableFilterSelectAll: false
    }

    $(function () {
      $('.wrapper1').on('scroll', function (e) {
        $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
      });
      $('.wrapper2').on('scroll', function (e) {
        $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
      });
      $('.div1').width($('table').width());
      $('.div2').width($('table').width());
    });

    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.initDependentFilterLoaders();
    this.GetAllContactColumn();
    this.getState();
    this.getScope();
    this.isloading = true;
    this.ContactsGetAll();
  }

  ngAfterViewInit() {
    this.patchCityFilterDropdown();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCityFilterOpen() {
    this.patchCityFilterDropdown();
    this.markCitySelectAllChecked();
  }

  private initDependentFilterLoaders() {
    this.countyLoad$.pipe(
      debounceTime(50),
      switchMap(stateId => {
        const requestSeq = this.countyApplySeq;
        return this.countyService.GetCountyByStateId(stateId, true).pipe(
          catchError(() => of(null)),
          map(result => ({ result: result, requestSeq: requestSeq }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(payload => this.applyCountyFilterData(payload.result, payload.requestSeq));

    this.cityLoad$.pipe(
      debounceTime(50),
      switchMap(countyId => {
        const requestSeq = this.cityApplySeq;
        return this.cityService.GetCityByCountyIdMultiple(this.tokenKey, countyId, true).pipe(
          catchError(() => of(null)),
          map(result => ({ result: result, requestSeq: requestSeq }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(payload => this.applyCityFilterData(payload.result, payload.requestSeq));
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.ContactsGetAll();
  }

  getScope() {
    this.main911Service.GetAllStateScope(this.tokenKey).subscribe(
      data => {
        this.scopeList = data['scope'];
        this.dropdownListScope = [];
        if (this.scopeList.length > 0) {
          this.scopeList.forEach(x => {
            this.dropdownListScope.push({ "id": x.scopeID, "itemName": x.scopeName })
          });
        }
      },
      error => { }
    );
  }

  onSelectScope($event) {
    this.listOfScopeIds = this.removeElemetninArray(this.listOfScopeIds, $event.id)
    this.listOfScopeIds.push($event.id);
    this.scopeId = ' ';
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectScope($event) {

    if (this.listOfScopeIds != null) {
      if (this.listOfScopeIds.length > 0) {
        this.listOfScopeIds = this.removeElemetninArray(this.listOfScopeIds, $event.id)
      }
    }
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();

  }

  onSelectAllScope($event) {
    for (const item of $event) {
      if (this.listOfScopeIds != null) {
        if (this.listOfScopeIds.length > 0) {
          this.listOfScopeIds = this.removeElemetninArray(this.listOfScopeIds, item.id)
          this.listOfScopeIds.push(item.id);
        }
        else {
          this.listOfScopeIds.push(item.id);
        }
      }
    }
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectAllScope($event) {
    this.listOfScopeIds = [];
    this.selectedItemsScope = [];
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }
      },
      error => { }
    );
  }

  GetCountyByStateId(stateId: any) {
    this.countyApplySeq++;
    if (!stateId || !String(stateId).trim()) {
      this.isCountyFilterLoading = false;
      this.dropdownSettingsCounty['noDataLabel'] = 'No County(s) available';
      this.dropdownListCounty = [];
      this.selectedItemsConuty = [];
      this.listOfCountyIds = [];
      this.clearCityFilter();
      return;
    }
    this.isCountyFilterLoading = true;
    this.dropdownSettingsCounty['noDataLabel'] = 'Loading counties...';
    this.countyLoad$.next(String(stateId));
  }

  GetCityByCountyId(countyId) {
    if (!countyId || !String(countyId).trim()) {
      this.clearCityFilter();
      return;
    }
    this.isAllCitiesSelected = false;
    this.cityApplySeq++;
    this.isCityFilterLoading = true;
    this.dropdownSettingsCity['noDataLabel'] = 'Loading cities...';
    this.cityLoad$.next(String(countyId));
  }

  private applyCountyFilterData(result: any, requestSeq: number) {
    if (requestSeq !== this.countyApplySeq) {
      return;
    }
    if (!result || result['status'] != 'Success') {
      this.isCountyFilterLoading = false;
      this.dropdownSettingsCounty['noDataLabel'] = 'No County(s) available';
      return;
    }

    const countyList = result['county'] || [];
    const selectedCountyIds = this.listOfCountyIds;

    this.ngZone.runOutsideAngular(() => {
      const selectedIdSet = {};
      for (let i = 0; i < selectedCountyIds.length; i++) {
        selectedIdSet[selectedCountyIds[i]] = true;
      }

      const dropdownItems = new Array(countyList.length);
      const selectedItems = [];
      const keptIds = [];
      for (let i = 0; i < countyList.length; i++) {
        const county = countyList[i];
        const item = { "id": county.countyId, "itemName": county.countyName };
        dropdownItems[i] = item;
        if (selectedIdSet[county.countyId]) {
          selectedItems.push(item);
          keptIds.push(county.countyId);
        }
      }

      setTimeout(() => {
        this.ngZone.run(() => {
          if (requestSeq !== this.countyApplySeq) {
            return;
          }
          this.countyList = countyList;
          this.dropdownListCounty = dropdownItems;
          this.selectedItemsConuty = selectedItems;
          this.listOfCountyIds = keptIds;
          this.isCountyFilterLoading = false;
          this.dropdownSettingsCounty['noDataLabel'] = 'No County(s) available';
          if (this.listOfCountyIds.length > 0) {
            this.countyId = this.listOfCountyIds.join(',');
            this.GetCityByCountyId(this.countyId);
          } else {
            this.clearCityFilter();
          }
        });
      }, 0);
    });
  }

  private applyCityFilterData(result: any, requestSeq: number) {
    if (requestSeq !== this.cityApplySeq) {
      return;
    }
    if (this.listOfCountyIds.length == 0) {
      this.clearCityFilter();
      return;
    }
    if (!result || result['status'] != 'Success') {
      this.isCityFilterLoading = false;
      this.dropdownSettingsCity['noDataLabel'] = 'No City(s) available';
      return;
    }

    const cityList = result['city'] || [];
    const selectedCityIds = this.listOfCityIds;
    const keepAllCities = this.isAllCitiesSelected;

    this.ngZone.runOutsideAngular(() => {
      const cityById = {};
      for (let i = 0; i < cityList.length; i++) {
        cityById[cityList[i].id] = cityList[i];
      }

      const keptIds = [];
      const selectedItems = [];
      const selectedIdMap = {};
      if (!keepAllCities) {
        for (let i = 0; i < selectedCityIds.length; i++) {
          const city = cityById[selectedCityIds[i]];
          if (city) {
            keptIds.push(selectedCityIds[i]);
            selectedItems.push(city);
            selectedIdMap[selectedCityIds[i]] = true;
          }
        }
      }

      setTimeout(() => {
        this.ngZone.run(() => {
          if (requestSeq !== this.cityApplySeq) {
            return;
          }
          this.cityList = cityList;
          this.dropdownListCity = cityList;
          this.isCityFilterLoading = false;
          this.dropdownSettingsCity['noDataLabel'] = 'No City(s) available';
          if (keepAllCities && cityList.length > 0) {
            this.applyAllCitiesSelection();
            return;
          }
          this.listOfCityIds = keptIds;
          this.citySelectedIdMap = selectedIdMap;
          this.setSelectedCityDisplay(selectedItems);
        });
      }, 0);
    });
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.GetCountyByStateId(this.stateId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length == 0) {
      this.countyApplySeq++;
      this.stateId = ' ';
      this.isCountyFilterLoading = false;
      this.dropdownSettingsCounty['noDataLabel'] = 'No County(s) available';
      this.dropdownListCounty = [];
      this.selectedItemsConuty = [];
      this.listOfCountyIds = [];
      this.clearCityFilter();
    }
    else {
      this.stateId = this.listOfStateIds.join(',')
      this.GetCountyByStateId(this.stateId);
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onSelectAll($event) {
    this.listOfStateIds = this.getIdsFromItems($event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectAllState($event) {
    this.countyApplySeq++;
    this.listOfStateIds = [];
    this.selectedItemsState = [];
    this.listOfCountyIds = [];
    this.selectedItemsConuty = [];
    this.dropdownListCounty = [];
    this.stateId = ' ';
    this.isCountyFilterLoading = false;
    this.dropdownSettingsCounty['noDataLabel'] = 'No County(s) available';
    this.clearCityFilter();
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onSelectCounty($event) {
    this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
    this.listOfCountyIds.push($event.id);
    this.countyId = ' ';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.GetCityByCountyId(this.countyId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectCounty($event) {
    if (this.listOfCountyIds != null) {
      if (this.listOfCountyIds.length > 0) {
        this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
      }
    }
    this.countyId = ' ';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    if (this.listOfCountyIds.length == 0) {
      this.clearCityFilter();
    }
    else {
      this.GetCityByCountyId(this.countyId);
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onSelectAllCounty($event) {
    this.listOfCountyIds = this.getIdsFromItems($event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectAllCounty($event) {
    this.listOfCountyIds = [];
    this.countyId = ' ';
    this.clearCityFilter();
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onSelectCity($event) {
    if (this.isApplyingCitySelection || this.isPlaceholderCityItem($event)) {
      return;
    }
    this.isAllCitiesSelected = false;
    this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, $event.id)
    this.listOfCityIds.push($event.id);
    this.citySelectedIdMap[$event.id] = true;
    this.selectedItemsCity = this.appendSelectedCityItem($event);
    this.resetPageNoandSize();
    this.compactSelectedCityIfNeeded();
    this.ContactsGetAll();
  }

  onDeSelectCity($event) {
    if (this.isApplyingCitySelection || this.isPlaceholderCityItem($event)) {
      this.clearCompactCitySelection();
      return;
    }
    this.isAllCitiesSelected = false;
    if (this.listOfCityIds != null) {
      if (this.listOfCityIds.length > 0) {
        this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, $event.id)
      }
    }
    delete this.citySelectedIdMap[$event.id];
    this.selectedItemsCity = (this.selectedItemsCity || []).filter(item => item && item.id !== $event.id);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onSelectAllCity($event) {
    this.applyAllCitiesSelection();
  }

  onDeSelectAllCity($event) {
    this.clearCompactCitySelection();
  }

  GetAllContactColumn() {
    this.main911Master.GetAllContactColumn(this.tokenKey).subscribe(
      data => {
        this.ColumnList = data['result'];
        this.dropdownListColumn = [];
        if (this.ColumnList.length > 0) {
          this.ColumnList.forEach(x => {
            this.dropdownListColumn.push({ "id": x.id, "itemName": x.columnName })
          });
        }
      },
      error => { }
    );
  }

  ContactsGetAll() {
    this.isloading = true;
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',');
    }
    this.countyId = " ";
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityId = " ";
    const cityFilterValue = this.getCityFilterValue();
    if (cityFilterValue) {
      this.cityId = cityFilterValue;
    }
    this.scopeId = " ";
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    if (this.filterText == "null") { this.filterText = " "; }
    this.listofContacts = [];
    this.main911Master.ContactsGetAll(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.countyId, this.cityId, this.scopeId, this.OrderBy, this.filterText, this.selectedItem, this.fromDate, this.toDate, this.fromDate1, this.toDate1, false).subscribe(
      data => {
        this.isloading = false;
        this.listofContacts = data['main'];
        if (this.listofContacts != null) {
          if (this.listofContacts.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofContacts[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => {
        this.isloading = false;
        this.stateCode = error
      }
    );
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.filterText = $event.target.value;
    else
      this.filterText = 'null';
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "cityName") {
        this.upDowCityNameCSS = 'fa fa-arrow-down';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactFirstName") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = 'fa fa-arrow-down';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactLastName") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = 'fa fa-arrow-down';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "LastContactDate") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = 'fa fa-arrow-down';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ConfirmationDate") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = 'fa fa-arrow-down';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactEmail") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = 'fa fa-arrow-down';
      }

    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "cityName") {
        this.upDowCityNameCSS = 'fa fa-arrow-up';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactFirstName") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = 'fa fa-arrow-up';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactLastName") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = 'fa fa-arrow-up';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "LastContactDate") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = 'fa fa-arrow-up';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ConfirmationDate") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = 'fa fa-arrow-up';
        this.upDowEmailCSS = '';
      }
      else if (sortBy === "ContactEmail") {
        this.upDowCityNameCSS = '';
        this.upDowFirstNameCSS = '';
        this.upDowLastNameCSS = '';
        this.upDowLastDateCSS = '';
        this.upDowConfiDateCSS = '';
        this.upDowEmailCSS = 'fa fa-arrow-down';
      }
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  addFund() {
    let navigation = '/admin/' + this.SelectedTool + '/fund/manage';
    this.router.navigate([navigation]);
  }

  updateFund(FundId) {
    let navigation = '/admin/' + this.SelectedTool + '/fund/manage/' + FundId;
    this.router.navigate([navigation]);
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  onSelectContactTable($event) {

    this.listofContactsTypeIds = [];
    this.listofContactsTypeIds = this.removeElemetninArray(this.listofContactsTypeIds, $event.id)
    this.listofContactsTypeIds.push($event.id);
    this.ContactTableId = ' ';
    if (this.listofContactsTypeIds.length > 0) {
      this.ContactTableId = this.listofContactsTypeIds.join(',')
    }
  }

  onDeSelectContactTable($event) {

    if (this.listofContactsTypeIds != null) {
      if (this.listofContactsTypeIds.length > 0) {
        this.listofContactsTypeIds = this.removeElemetninArray(this.listofContactsTypeIds, $event.id)
      }
    }
    if (this.listofContactsTypeIds.length > 0) {
      this.ContactTableId = this.listofContactsTypeIds.join(',')
    }
  }

  onSelectAllContactTable($event) {

    this.listofContactsTypeIds = [];
    for (const item of $event) {
      if (this.listofContactsTypeIds != null) {
        if (this.listofContactsTypeIds.length > 0) {
          this.listofContactsTypeIds = this.removeElemetninArray(this.listofContactsTypeIds, item.id)
          this.listofContactsTypeIds.push(item.id);
        }
        else {
          this.listofContactsTypeIds.push(item.id);
        }
      }
    }
  }

  onDeSelectAllContactTable($event) {
    this.listofContactsTypeIds = [];
  }

  GetContactsTable() {
    this.main911Master.GetContactsTable(this.tokenKey).subscribe(
      data => {
        this.listofContactsTable = data['main'];
        if (this.listofContactsTable.length > 0) {
          this.listofContactsTable.forEach(x => {
            this.dropdownListContactTable.push({ "id": x.id, "itemName": x.tableName })
          });
        }
      },
      error => { this.stateCode = error }
    );
  }

  ContactsStateGetAll() {
    this.main911Master.ContactsStateGetAll(this.tokenKey).subscribe(
      data => {
        this.stateList = data['main'];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.id, "itemName": x.stateName })
          });
        }

      },
      error => { this.stateCode = error }
    );
  }

  addContact() {
    let navigation = '/admin/' + this.SelectedTool + '/contacts/manage';
    this.router.navigate([navigation]);
  }

  updateContact(id) {
    if (id != undefined && id > 0) {
      window.open('/#/admin/' + this.SelectedTool + '/contacts/manage/' + id, "_blank");
    }
  }

  setDeleteData(id) {
    this.contactId = id;
  }

  deleteContact(deletedId) {
    this.isloading = true;
    this.main911Master.DeleteContact(this.tokenKey, deletedId).subscribe(
      data => {
        this.ContactsGetAll();
        this.toastr.success('Contacts deleted successfully.', 'Delete')
      },
      error => { }
    );
  }

  onSelectColumn($event) {
    this.selectedItem = $event.itemName;
    this.ColumnId = $event.id;
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectColumn($event) {
    this.selectedItem = '';
    this.ColumnId = 0;
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onDeSelectAllColumn($event) {
    this.selectedItem = '';
    this.selectedItemsColumn = [];
    this.ContactsGetAll();
  }

  isLastConfDatesFilter(value: any) {
    if (value != null) {
      if (value.length == 2) {
        this.PageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.fromDate = a;
        this.toDate = f;
        this.ContactsGetAll();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  clearLastDate() {
    this.rangeOfLastConfDates = [];
    this.resetPageNoandSize();
    this.fromDate = '';
    this.toDate = '';
    this.ContactsGetAll();
  }

  isConfDatesFilter(value: any) {
    if (value != null) {
      if (value.length == 2) {
        this.PageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.fromDate1 = a;
        this.toDate1 = f;
        this.ContactsGetAll();
      }
    }
  }

  clearConfDate() {
    this.rangeOfConfDates = [];
    this.resetPageNoandSize();
    this.fromDate1 = '';
    this.toDate1 = '';
    this.ContactsGetAll();
  }

  onFilterSelectAllState($event) {
    this.listOfStateIds = this.addIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onFilterDeSelectAllState($event) {
    this.listOfStateIds = this.removeIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onFilterSelectAllCounty($event) {
    this.listOfCountyIds = this.addIdsFromItems(this.listOfCountyIds, $event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onFilterDeSelectAllCounty($event) {
    this.listOfCountyIds = this.removeIdsFromItems(this.listOfCountyIds, $event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onFilterSelectAllCity($event) {
    this.applyLargeCitySelection($event);
  }

  onFilterDeSelectAllCity($event) {
    this.isAllCitiesSelected = false;
    this.listOfCityIds = this.removeIdsFromItems(this.listOfCityIds, $event);
    if ($event) {
      for (let i = 0; i < $event.length; i++) {
        delete this.citySelectedIdMap[$event[i].id];
      }
    }
    this.resetPageNoandSize();
    if (this.listOfCityIds.length == 0) {
      this.citySelectedIdMap = {};
      this.selectedItemsCity = [];
      this.syncCityDropdownSelection([]);
    }
    else if (this.listOfCityIds.length > this.cityBadgeLimit) {
      this.selectedItemsCity = [this.buildCityCountPlaceholder(this.listOfCityIds.length)];
      this.syncCityDropdownSelection(this.selectedItemsCity, false);
    }
    this.ContactsGetAll();
  }

  onFilterSelectAllScope($event) {
    for (const item of $event) {
      if (this.listOfScopeIds != null) {
        if (this.listOfScopeIds.length > 0) {
          this.listOfScopeIds = this.removeElemetninArray(this.listOfScopeIds, item.id)
          this.listOfScopeIds.push(item.id);
        }
        else {
          this.listOfScopeIds.push(item.id);
        }
      }
    }
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  onFilterDeSelectAllScope($event) {
    for (const item of $event) {
      if (this.listOfScopeIds != null) {
        if (this.listOfScopeIds.length > 0) {
          this.listOfScopeIds = this.removeElemetninArray(this.listOfScopeIds, item.id)
        }
      }
    }
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    this.resetPageNoandSize();
    this.ContactsGetAll();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  Export911Contacts() {
    this.isloading = true;
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',');
    }
    this.countyId = " ";
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityId = " ";
    const cityFilterValue = this.getCityFilterValue();
    if (cityFilterValue) {
      this.cityId = cityFilterValue;
    }
    this.scopeId = " ";
    if (this.listOfScopeIds.length > 0) {
      this.scopeId = this.listOfScopeIds.join(',')
    }
    if (this.filterText == "null") { this.filterText = " "; }

    this.listofContactsExport = [];
    this.main911Master.ContactsGetAll(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.countyId, this.cityId, this.scopeId, this.OrderBy, this.filterText, this.selectedItem, this.fromDate, this.toDate, this.fromDate1, this.toDate1, true).subscribe(
      data => {
        this.listofContactsExport = data['main'];
        if (this.listofContactsExport != null) {
          if (this.listofContactsExport.length > 0) {
            setTimeout(() => {
              this.Download911Contacts();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
        this.stateCode = error
      }
    );
  }

  Download911Contacts() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'Export911Contacts';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "Export911Contacts.xls");
  }

  private clearCityFilter() {
    this.cityApplySeq++;
    this.citySelectionSeq++;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = false;
    this.isCityFilterLoading = false;
    this.citySelectedIdMap = {};
    this.dropdownSettingsCity['noDataLabel'] = 'No City(s) available';
    this.listOfCityIds = [];
    this.selectedItemsCity = [];
    this.dropdownListCity = [];
    this.cityId = ' ';
    this.syncCityDropdownSelection([]);
  }

  private getCityFilterValue(): string {
    if (this.isAllCitiesSelected) {
      return '';
    }
    if (!this.listOfCityIds || this.listOfCityIds.length == 0) {
      return '';
    }
    return this.listOfCityIds.join(',');
  }

  private patchCityFilterDropdown() {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown || dropdown.__cityFilterPatched) {
      this.cityDropdownPatched = !!dropdown;
      return;
    }

    const self = this;
    const originalIsSelected = dropdown.isSelected.bind(dropdown);
    const originalOnItemClick = dropdown.onItemClick.bind(dropdown);
    const originalNgDoCheck = dropdown.ngDoCheck ? dropdown.ngDoCheck.bind(dropdown) : null;

    dropdown.isSelected = function (item) {
      if (self.isAllCitiesSelected) {
        return true;
      }
      if (item && self.citySelectedIdMap[item.id]) {
        return true;
      }
      return originalIsSelected(item);
    };

    dropdown.ngDoCheck = function () {
      if (self.isAllCitiesSelected && this.data && this.data.length > 0) {
        this.isSelectAll = true;
        return;
      }
      if (originalNgDoCheck) {
        originalNgDoCheck();
      }
    };

    dropdown.toggleSelectAll = function () {
      if (!this.isSelectAll && !self.isAllCitiesSelected) {
        self.applyAllCitiesSelection();
      } else {
        self.clearCompactCitySelection();
      }
    };

    dropdown.toggleInfiniteFilterSelectAll = function () {
      const items = this.virtualdata || [];
      if (!this.isInfiniteFilterSelectAll) {
        if (items.length > self.cityBadgeLimit) {
          self.applyLargeCitySelection(items);
          this.isInfiniteFilterSelectAll = true;
          return;
        }
        for (let i = 0; i < items.length; i++) {
          if (!this.isSelected(items[i])) {
            this.addSelected(items[i]);
          }
        }
        this.isInfiniteFilterSelectAll = true;
        self.onFilterSelectAllCity(items);
        return;
      }

      if (self.isAllCitiesSelected || self.isPlaceholderCitySelection(self.selectedItemsCity)) {
        self.clearCompactCitySelection();
        this.isInfiniteFilterSelectAll = false;
        return;
      }
      for (let i = 0; i < items.length; i++) {
        if (this.isSelected(items[i])) {
          this.removeSelected(items[i]);
        }
      }
      this.isInfiniteFilterSelectAll = false;
      self.onFilterDeSelectAllCity(items);
    };

    dropdown.onItemClick = function (item, index, event) {
      if (self.isAllCitiesSelected) {
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      if (self.isPlaceholderCitySelection(self.selectedItemsCity)) {
        self.toggleCompactCitySelection(item);
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      return originalOnItemClick(item, index, event);
    };

    dropdown.__cityFilterPatched = true;
    this.cityDropdownPatched = true;
  }

  private applyAllCitiesSelection() {
    const cityCount = this.dropdownListCity ? this.dropdownListCity.length : 0;
    this.citySelectionSeq++;
    this.isApplyingCitySelection = true;
    this.isAllCitiesSelected = cityCount > 0;
    this.isCitySelectionLoading = false;
    this.citySelectedIdMap = {};
    this.listOfCityIds = [];
    this.resetPageNoandSize();
    this.selectedItemsCity = cityCount > 0 ? [this.buildAllCitiesPlaceholder(cityCount)] : [];
    this.syncCityDropdownSelection(this.selectedItemsCity, true);
    this.markCitySelectAllChecked();
    setTimeout(() => {
      this.markCitySelectAllChecked();
      this.isApplyingCitySelection = false;
      this.ContactsGetAll();
    }, 0);
  }

  private applyLargeCitySelection(items: any[]) {
    items = items || [];
    this.resetPageNoandSize();
    if (this.dropdownListCity && this.dropdownListCity.length > 0
      && items.length === this.dropdownListCity.length) {
      this.applyAllCitiesSelection();
      return;
    }

    const seq = ++this.citySelectionSeq;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = true;
    this.isApplyingCitySelection = true;
    this.selectedItemsCity = [this.buildCityCountPlaceholder(items.length)];
    this.syncCityDropdownSelection(this.selectedItemsCity, false);

    this.ngZone.runOutsideAngular(() => {
      const ids = new Array(items.length);
      const selectedIdMap = {};
      for (let i = 0; i < items.length; i++) {
        ids[i] = items[i].id;
        selectedIdMap[items[i].id] = true;
      }
      this.ngZone.run(() => {
        if (seq !== this.citySelectionSeq) {
          this.isApplyingCitySelection = false;
          return;
        }
        this.listOfCityIds = ids;
        this.citySelectedIdMap = selectedIdMap;
        this.selectedItemsCity = [this.buildCityCountPlaceholder(ids.length)];
        this.syncCityDropdownSelection(this.selectedItemsCity, false);
        this.isCitySelectionLoading = false;
        this.ContactsGetAll();
        setTimeout(() => {
          this.isApplyingCitySelection = false;
        }, 0);
      });
    });
  }

  private clearCompactCitySelection() {
    this.citySelectionSeq++;
    this.isApplyingCitySelection = true;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = false;
    this.citySelectedIdMap = {};
    this.listOfCityIds = [];
    this.selectedItemsCity = [];
    this.resetPageNoandSize();
    this.syncCityDropdownSelection([]);
    this.ContactsGetAll();
    setTimeout(() => {
      this.isApplyingCitySelection = false;
    }, 0);
  }

  private toggleCompactCitySelection(item: any) {
    if (!item || this.isPlaceholderCityItem(item)) {
      return;
    }
    if (this.citySelectedIdMap[item.id]) {
      delete this.citySelectedIdMap[item.id];
      this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, item.id);
    } else {
      this.citySelectedIdMap[item.id] = true;
      this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, item.id);
      this.listOfCityIds.push(item.id);
    }
    this.resetPageNoandSize();
    if (this.listOfCityIds.length == 0) {
      this.clearCompactCitySelection();
      return;
    }
    this.selectedItemsCity = [this.buildCityCountPlaceholder(this.listOfCityIds.length)];
    this.syncCityDropdownSelection(this.selectedItemsCity, false);
    this.ContactsGetAll();
  }

  private compactSelectedCityIfNeeded() {
    if (!this.selectedItemsCity || this.selectedItemsCity.length <= this.cityBadgeLimit
      || this.isPlaceholderCitySelection(this.selectedItemsCity)) {
      return;
    }
    this.listOfCityIds = this.getIdsFromItems(this.selectedItemsCity);
    this.citySelectedIdMap = {};
    for (let i = 0; i < this.listOfCityIds.length; i++) {
      this.citySelectedIdMap[this.listOfCityIds[i]] = true;
    }
    this.setSelectedCityDisplay(this.selectedItemsCity);
  }

  private setSelectedCityDisplay(selectedItems: any[]) {
    selectedItems = selectedItems || [];
    if (selectedItems.length > this.cityBadgeLimit) {
      this.selectedItemsCity = [this.buildCityCountPlaceholder(selectedItems.length)];
    } else {
      this.selectedItemsCity = selectedItems;
    }
    this.syncCityDropdownSelection(this.selectedItemsCity, this.isAllCitiesSelected);
  }

  private syncCityDropdownSelection(selectedItems: any[], selectAll?: boolean) {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.selectedItems = selectedItems || [];
    dropdown.isSelectAll = !!selectAll || this.isAllCitiesSelected;
    if (typeof dropdown.onChangeCallback === 'function') {
      dropdown.onChangeCallback(dropdown.selectedItems);
    }
    this.markCitySelectAllChecked();
  }

  private markCitySelectAllChecked() {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.isSelectAll = this.isAllCitiesSelected && !!(this.dropdownListCity && this.dropdownListCity.length > 0);
  }

  private buildAllCitiesPlaceholder(count: number) {
    return { id: this.allCitiesPlaceholderId, itemName: 'All Cities (' + count + ')' };
  }

  private buildCityCountPlaceholder(count: number) {
    return { id: this.manyCitiesPlaceholderId, itemName: count + ' Cities' };
  }

  private isPlaceholderCitySelection(items: any[]): boolean {
    return !!(items && items.length == 1 && this.isPlaceholderCityItem(items[0]));
  }

  private isPlaceholderCityItem(item: any): boolean {
    return !!(item && (item.id === this.allCitiesPlaceholderId || item.id === this.manyCitiesPlaceholderId));
  }

  private appendSelectedCityItem(item: any): any[] {
    const selectedItems = this.selectedItemsCity ? this.selectedItemsCity.slice() : [];
    for (let i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i] && selectedItems[i].id === item.id) {
        return selectedItems;
      }
    }
    selectedItems.push(item);
    return selectedItems;
  }

  private getIdsFromItems(items: any[]): any[] {
    if (!items || items.length == 0) {
      return [];
    }
    const ids = new Array(items.length);
    for (let i = 0; i < items.length; i++) {
      ids[i] = items[i].id;
    }
    return ids;
  }

  private addIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!items || items.length == 0) {
      return existingIds || [];
    }
    const idSet = {};
    const result = existingIds ? existingIds.slice() : [];
    for (let i = 0; i < result.length; i++) {
      idSet[result[i]] = true;
    }
    for (let i = 0; i < items.length; i++) {
      const id = items[i].id;
      if (!idSet[id]) {
        idSet[id] = true;
        result.push(id);
      }
    }
    return result;
  }

  private removeIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!existingIds || existingIds.length == 0) {
      return [];
    }
    if (!items || items.length == 0) {
      return existingIds;
    }
    const removeSet = {};
    for (let i = 0; i < items.length; i++) {
      removeSet[items[i].id] = true;
    }
    const result = [];
    for (let i = 0; i < existingIds.length; i++) {
      if (!removeSet[existingIds[i]]) {
        result.push(existingIds[i]);
      }
    }
    return result;
  }
}
